'use client';

import { RegionFinderContent } from '@/app/donation/_components/RegionFinderContent';
import { useRegionFinder } from '@/app/donation/_hooks/useRegionFinder';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';

interface RegionFinderDialogProps {
  opened: boolean;
  onClose: () => void;
}

export const RegionFinderDialog = ({
  opened,
  onClose,
}: RegionFinderDialogProps) => {
  const finder = useRegionFinder({ enabled: opened });

  //* 닫을 때 검색어를 되돌린다 — 상태가 이 컴포넌트에 남아 다시 열면 이전 검색이 보인다
  const handleClose = () => {
    finder.reset();
    onClose();
  };

  return (
    <ResponsiveDialog
      isAppBarHeader
      drawerNoPadding
      modalHeader="지역찾기"
      opened={opened}
      onClose={handleClose}
      title="지역찾기"
    >
      <div className="flex h-full flex-col xl:h-[70dvh]">
        <RegionFinderContent
          finder={finder}
          onSelect={(id) => {
            handleClose();
            finder.handleSelectRegion(id);
          }}
        />
      </div>
    </ResponsiveDialog>
  );
};
